import { render, staticRenderFns } from "./ZStepHeader.vue?vue&type=template&id=980922c8&"
import script from "./ZStepHeader.vue?vue&type=script&lang=ts&"
export * from "./ZStepHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports